import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";

/**
 * Returns whether the Product V2 presentation is active for the current platform.
 *
 * The flag covers Product and intermediate-product flows plus related Ingredient,
 * Packaging, Supplier, Transformation and Transport surfaces. The Product V2
 * score-detail shell is limited to finished products; other feature flags and RBAC
 * still govern availability.
 *
 * Orthogonal to `FS-product-distribution` / `FS-product-consumption` which gate
 * the Ecobalyse Distribution / Consumption steps individually inside both v1 and v2.
 */
export const useIsProductUxV2 = (): boolean => {
    const { isFeatureActivated } = useApplicationParameters();
    return isFeatureActivated("FS-product-ux-v2");
};
